<template>
  <base-message-page title="404 Pagina non trovata" />
</template>

<script>
import BaseMessagePage from '@/components/BaseMessagePage.vue'

export default {
  components: {
    BaseMessagePage,
  },
}
</script>
